var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2 21.25H6.93137C6.32555 21.25 6.02265 21.25 5.88238 21.1302C5.76068 21.0263 5.69609 20.8703 5.70865 20.7108C5.72312 20.5269 5.93731 20.3127 6.36569 19.8843L14.8686 11.3814C15.2646 10.9854 15.4627 10.7873 15.691 10.7132C15.8918 10.6479 16.1082 10.6479 16.309 10.7132C16.5373 10.7873 16.7354 10.9854 17.1314 11.3814L21 15.25V16.45M16.2 21.25C17.8802 21.25 18.7202 21.25 19.362 20.923C19.9265 20.6354 20.3854 20.1765 20.673 19.612C21 18.9702 21 18.1302 21 16.45M16.2 21.25H7.8C6.11984 21.25 5.27976 21.25 4.63803 20.923C4.07354 20.6354 3.6146 20.1765 3.32698 19.612C3 18.9702 3 18.1302 3 16.45V8.05C3 6.36984 3 5.52976 3.32698 4.88803C3.6146 4.32354 4.07354 3.8646 4.63803 3.57698C5.27976 3.25 6.11984 3.25 7.8 3.25H16.2C17.8802 3.25 18.7202 3.25 19.362 3.57698C19.9265 3.8646 20.3854 4.32354 20.673 4.88803C21 5.52976 21 6.36984 21 8.05V16.45M10.5 8.75C10.5 9.85457 9.60457 10.75 8.5 10.75C7.39543 10.75 6.5 9.85457 6.5 8.75C6.5 7.64543 7.39543 6.75 8.5 6.75C9.60457 6.75 10.5 7.64543 10.5 8.75Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage1);
export default __webpack_public_path__ + "static/media/image-1.4ea8dfc6bec89011c2320ef40d13b860.svg";
export { ForwardRef as ReactComponent };